import { render } from "./ViewLoader.vue?vue&type=template&id=6fadd286&scoped=true"
import script from "./ViewLoader.vue?vue&type=script&lang=js"
export * from "./ViewLoader.vue?vue&type=script&lang=js"

import "./ViewLoader.vue?vue&type=style&index=0&id=6fadd286&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fadd286"],['__file',"src/common/components/ViewLoader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fadd286"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fadd286', __exports__)) {
    api.reload('6fadd286', __exports__)
  }
  
  module.hot.accept("./ViewLoader.vue?vue&type=template&id=6fadd286&scoped=true", () => {
    api.rerender('6fadd286', render)
  })

}


export default __exports__